<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div id="background"></div>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-aihobs-ecs-login></app-aihobs-ecs-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-aihobs-ecs-register></app-aihobs-ecs-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-aihobs-ecs-forgot-password></app-aihobs-ecs-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-aihobs-ecs-change-password-sent></app-aihobs-ecs-change-password-sent>
  </div>

  <app-aihobs-ecs-register-resend
    *ngIf="page === 'register-resend'"
  ></app-aihobs-ecs-register-resend>
</ng-container>
